import { __assign, __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { MDCRipple, MDCRippleFoundation } from '@material/ripple';
import { MDCTabIndicator } from '@material/tab-indicator';
import { toggleClass } from '../../core/utils';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { TAB_CONSTANTS } from './tab-constants';
var TabRippleSurface = /** @class */ (function () {
    function TabRippleSurface(_root) {
        this._root = _root;
    }
    Object.defineProperty(TabRippleSurface.prototype, "root_", {
        get: function () {
            return this._root;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabRippleSurface.prototype, "unbounded", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabRippleSurface.prototype, "disabled", {
        get: function () {
            return this._root.disabled;
        },
        enumerable: true,
        configurable: true
    });
    return TabRippleSurface;
}());
var TabAdapter = /** @class */ (function (_super) {
    __extends(TabAdapter, _super);
    function TabAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._buttonElement = getShadowElement(_this._component, TAB_CONSTANTS.selectors.BUTTON);
        _this._content = getShadowElement(_this._component, TAB_CONSTANTS.selectors.CONTENT);
        _this._rippleElement = getShadowElement(_this._component, TAB_CONSTANTS.selectors.RIPPLE);
        _this._tabIndicatorElement = getShadowElement(_this._component, TAB_CONSTANTS.selectors.INDICATOR);
        return _this;
    }
    TabAdapter.prototype.initialize = function () {
        this._component.setAttribute('role', 'tab');
    };
    TabAdapter.prototype.initializeRipple = function () {
        var _this = this;
        var rippleCapableSurface = new TabRippleSurface(this._buttonElement);
        var rippleAdapter = __assign(__assign({}, MDCRipple.createAdapter(rippleCapableSurface)), { addClass: function (className) { return _this._rippleElement.classList.add(className); }, removeClass: function (className) { return _this._rippleElement.classList.remove(className); }, updateCssVariable: function (varName, value) { return _this._rippleElement.style.setProperty(varName, value); } });
        var rippleFoundation = new MDCRippleFoundation(rippleAdapter);
        this._rippleInstance = new MDCRipple(this._buttonElement, rippleFoundation);
    };
    TabAdapter.prototype.destroyRipple = function () {
        if (this._rippleInstance) {
            this._rippleInstance.destroy();
        }
    };
    TabAdapter.prototype.initializeIndicator = function () {
        this._tabIndicator = new MDCTabIndicator(this._tabIndicatorElement);
    };
    TabAdapter.prototype.destroyIndicator = function () {
        if (this._tabIndicator) {
            this._tabIndicator.destroy();
            this._tabIndicator = undefined;
        }
    };
    TabAdapter.prototype.activateIndicator = function (previousIndicatorClientRect) {
        if (this._tabIndicator) {
            this._tabIndicator.activate(previousIndicatorClientRect);
        }
    };
    TabAdapter.prototype.deactivateIndicator = function () {
        if (this._tabIndicator) {
            this._tabIndicator.deactivate();
        }
    };
    TabAdapter.prototype.computeIndicatorBounds = function () {
        return this._tabIndicator ? this._tabIndicator.computeContentClientRect() : undefined;
    };
    TabAdapter.prototype.addButtonListener = function (type, listener) {
        this._buttonElement.addEventListener(type, listener);
    };
    TabAdapter.prototype.removeButtonListener = function (type, listener) {
        this._buttonElement.removeEventListener(type, listener);
    };
    TabAdapter.prototype.setDisabled = function (value) {
        this._buttonElement.disabled = value;
        this.setTabIndex(!value ? 0 : -1);
        this._component.setAttribute('aria-disabled', value.toString());
    };
    TabAdapter.prototype.setActive = function (value) {
        toggleClass(this._buttonElement, value, TAB_CONSTANTS.classes.ACTIVE);
        this.setTabIndex(value ? 0 : -1);
        this._component.setAttribute('aria-selected', value.toString());
    };
    TabAdapter.prototype.getOffsetLeft = function () {
        return this._buttonElement.offsetLeft;
    };
    TabAdapter.prototype.getOffsetWidth = function () {
        return this._buttonElement.offsetWidth;
    };
    TabAdapter.prototype.getContentOffsetLeft = function () {
        return this._content.offsetLeft;
    };
    TabAdapter.prototype.getContentOffsetWidth = function () {
        return this._content.offsetWidth;
    };
    TabAdapter.prototype.focus = function () {
        this._buttonElement.focus();
    };
    TabAdapter.prototype.setTabIndex = function (value) {
        this._buttonElement.tabIndex = value;
    };
    return TabAdapter;
}(BaseAdapter));
export { TabAdapter };
